<script lang="ts" setup>
/* Types */
import { DeliveryMethods } from '@/types/api/api-v3/basket'
import {
  PaymentMethod,
  PaymentMethodIcons,
  PaymentMethodName,
  PaymentMethodType,
} from '@/types/api/api-v3/paymentMethods'

type Props = {
  payment: PaymentMethod
  methodDelivery: DeliveryMethods
}
const props = defineProps<Props>()

// Формируем наименование способа оплат, с исключением для картой курьеру/в ресторане
const namePaymentMethod = computed(() => {
  if (props.payment.type !== PaymentMethodType.CARD)
    return PaymentMethodName[props.payment.type]

  const prefix =
    props.methodDelivery === DeliveryMethods.COURIER ? '_courier' : ''

  return PaymentMethodName[`${PaymentMethodType.CARD}${prefix}`]
})

// Через тип оплаты определяем размеры иконок
const iconClasses = computed(() => {
  const classes = ['payment-method__icon']

  if (props.payment.type === PaymentMethodType.SBP) {
    classes.push('payment-method__icon--sbp')
  }

  return classes
})

const paymentIcon = computed(() => PaymentMethodIcons[props.payment.type])
</script>

<template>
  <div class="payment-method">
    <nuxt-img v-if="paymentIcon" :class="iconClasses" :src="paymentIcon" />

    <p class="payment-method__text">
      {{ namePaymentMethod }}
    </p>
  </div>
</template>

<style lang="scss" scoped>
.payment-method {
  &__icon {
    width: 24px;
    height: 24px;
  }

  &__text {
    overflow: hidden;
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;

    @include media('>=tablet') {
      font-size: 14px;
      line-height: 19px;
    }
  }
}
</style>
